import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd5ff65c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-pwsetting l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "パスワード再設定", -1))
const _hoisted_4 = { class: "ha__sec ha-pwsetting__sec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-messages" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ha-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "ha-message__txt ha-message__txt--primary" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "英字大文字、英字小文字、数字いずれも含む8文字以上のパスワードを設定してください。")
    ])
  ])
], -1))
const _hoisted_6 = { class: "p-pwsetting__field-container" }
const _hoisted_7 = { class: "p-errors" }
const _hoisted_8 = { class: "c-error" }
const _hoisted_9 = { class: "p-fields" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newPassword"
}, "パスワード", -1))
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__note" }, "（英字大文字、英字小文字、数字を含む8文字以上）", -1))
const _hoisted_15 = { class: "c-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newPasswordRetype"
}, "新しいパスワード(確認）", -1))
const _hoisted_17 = { class: "c-field__body" }
const _hoisted_18 = { class: "c-field__input" }
const _hoisted_19 = { class: "c-field has-submit has-mt" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "送信する", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Form, {
          onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.setPassword, this))),
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors, meta }) => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errorMsgRef), 1)
              ], 512), [
                [_vShow, _ctx.errorMsgRef]
              ]),
              _createElementVNode("fieldset", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        type: _ctx.newPasswordToggle.fieldType,
                        id: "newPassword",
                        name: "newPassword",
                        modelValue: _ctx.newPasswordRef,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPasswordRef) = $event)),
                        maxlength: _ctx.PASSWORD_MAX_LENGTH,
                        placeholder: "新しいパスワード",
                        autocomplete: "new-password",
                        required: ""
                      }, null, 8, ["type", "modelValue", "maxlength"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordToggle.isOn }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordToggle)))
                      }, null, 2)
                    ]),
                    _hoisted_14
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPassword), 513), [
                  [_vShow, errors.newPassword]
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Field, {
                        type: _ctx.newPasswordRetypeToggle.fieldType,
                        id: "newPasswordRetype",
                        name: "newPasswordRetype",
                        modelValue: _ctx.newPasswordRetypeRef,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPasswordRetypeRef) = $event)),
                        maxlength: _ctx.PASSWORD_MAX_LENGTH,
                        placeholder: "新しいパスワード確認",
                        autocomplete: "new-password",
                        required: ""
                      }, null, 8, ["type", "modelValue", "maxlength"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordRetypeToggle.isOn }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordRetypeToggle)))
                      }, null, 2)
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPasswordRetype), 513), [
                  [_vShow, errors.newPasswordRetype]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "ha-btn is-submit",
                    disabled: !meta.valid || _ctx.isDeterringRef
                  }, _hoisted_22, 8, _hoisted_20),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.back())),
                    class: _normalizeClass(["ha-btn ha-btn--sub", { 'is-disabled':_ctx.isDeterringRef }])
                  }, _hoisted_24, 2)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ])
  ]))
}